import { defineStore } from 'pinia';

export const useSidebarStore = defineStore('sidebar', {
    state: () => ({
        isSidebarActive: true
    }),
    actions: {
        toggleSidebar() {
            this.isSidebarActive = !this.isSidebarActive;
        },
        setSidebarState(state) {
            this.isSidebarActive = state;
        }
    }
});
